module.exports = __webpack_public_path__ + "01_medium_gray.8eab4549.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/okuta/dad/layer5/01_medium_gray.png
// module id = mC73
// module chunks = 0